import { createAction } from '@reduxjs/toolkit';
import { API, ErrorObject, LLMPromptTemplate, UUID } from 'types';

export const fetchPromptTemplates = createAction<
  { kind?: string; relationships?: string[]; limit?: number } | undefined
>('PROMPT_TEMPLATES/FETCH_PROMPT_TEMPLATES');
export const fetchPromptTemplatesRequest = createAction(
  'PROMPT_TEMPLATES/FETCH_PROMPT_TEMPLATES_REQUEST'
);
export const fetchPromptTemplatesFailure = createAction<ErrorObject>(
  'PROMPT_TEMPLATES/FETCH_PROMPT_TEMPLATES_FAILURE'
);
export const fetchPromptTemplatesSuccess = createAction<API.WrappedAPIResponse<LLMPromptTemplate>>(
  'PROMPT_TEMPLATES/FETCH_PROMPT_TEMPLATES_SUCCESS'
);
export const fetchPromptTemplatesFulfill = createAction(
  'PROMPT_TEMPLATES/FETCH_PROMPT_TEMPLATES_FULFILL'
);

type UpsetPromptTemplatePayload = Partial<LLMPromptTemplate>;

export const upsertPromptTemplate = createAction<UpsetPromptTemplatePayload>(
  'PROMPT_TEMPLATES/UPSERT_PROMPT_TEMPLATE'
);
export const upsertPromptTemplateRequest = createAction(
  'PROMPT_TEMPLATES/UPSERT_PROMPT_TEMPLATE_REQUEST'
);
export const upsertPromptTemplateFailure = createAction<ErrorObject>(
  'PROMPT_TEMPLATES/UPSERT_PROMPT_TEMPLATE_FAILURE'
);
export const upsertPromptTemplateSuccess = createAction<LLMPromptTemplate>(
  'PROMPT_TEMPLATES/UPSERT_PROMPT_TEMPLATE_SUCCESS'
);

export const upsertAndAddPromptTemplate = createAction<
  UpsetPromptTemplatePayload & { parent?: string }
>('PROMPT_TEMPLATES/UPSERT_AND_ADD_PROMPT_TEMPLATE');
export const upsertAndAddPromptTemplateRequest = createAction(
  'PROMPT_TEMPLATES/UPSERT_AND_ADD_PROMPT_TEMPLATE_REQUEST'
);
export const upsertAndAddPromptTemplateFailure = createAction<ErrorObject>(
  'PROMPT_TEMPLATES/UPSERT_AND_ADD_PROMPT_TEMPLATE_FAILURE'
);
export const upsertAndAddPromptTemplateSuccess = createAction<LLMPromptTemplate>(
  'PROMPT_TEMPLATES/UPSERT_AND_ADD_PROMPT_TEMPLATE_SUCCESS'
);

export const deletePromptTemplate = createAction<{ uuid: UUID; redirect?: boolean }>(
  'PROMPT_TEMPLATES/DELETE_PROMPT_TEMPLATE'
);
export const deletePromptTemplateRequest = createAction(
  'PROMPT_TEMPLATES/DELETE_PROMPT_TEMPLATE_REQUEST'
);
export const deletePromptTemplateFailure = createAction<ErrorObject>(
  'PROMPT_TEMPLATES/DELETE_PROMPT_TEMPLATE_FAILURE'
);
export const deletePromptTemplateSuccess = createAction<{ uuid: UUID }>(
  'PROMPT_TEMPLATES/DELETE_PROMPT_TEMPLATE_SUCCESS'
);

export const fetchSinglePromptTemplate = createAction<{ promptTemplateId: UUID }>(
  'PROMPT_TEMPLATES/FETCH_SINGLE_PROMPT_TEMPLATE'
);
export const fetchSinglePromptTemplateRequest = createAction(
  'PROMPT_TEMPLATES/FETCH_SINGLE_PROMPT_TEMPLATE_REQUEST'
);
export const fetchSinglePromptTemplateFailure = createAction<ErrorObject>(
  'PROMPT_TEMPLATES/FETCH_SINGLE_PROMPT_TEMPLATE_FAILURE'
);
export const fetchSinglePromptTemplateSuccess = createAction<LLMPromptTemplate>(
  'PROMPT_TEMPLATES/FETCH_SINGLE_PROMPT_TEMPLATE_SUCCESS'
);
